import React from 'react';
import RatesForm from './RatesForm'; // Adjust path

const NewRatePage = () => {
    return <RatesForm formType="create" currentRateId={null} />;
};

export default NewRatePage;